import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("hh_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const fileUrl = (path) => `${API}/files/${path}`;

export const hirePhoto = (h) => (h.storage_path ? fileUrl(h.storage_path) : h.photo_url);

export default API;
